// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex-auto {
  flex: 1 0 auto !important;
}

.measurement-list {
  margin-bottom: 140px;
}

.measurement-card {
  padding: 10px;
}

.device-status {
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
  align-self: center;
  text-align: center;
}

._ag-card {
  margin-bottom: 10px;
  _border: 2px solid #fff;
  border-radius: 7px;
  margin: 20px;
  padding: 10px;
  background-color: #fff;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
}

.not_synced {
  filter: grayscale(1);
}

.moisture-row {
  _margin-bottom: 8px;
}
.moisture-row .icon {
  width: 38px;
  height: 38px;
  margin: 0;
}
.moisture-row .moisture-value {
  color: #303c42;
  margin-left: 5px;
  height: 40px;
  font-size: 30px;
  font-weight: 500;
  line-height: 40px;
  text-align: center;
}

.moisture-crop {
  margin-top: 5px;
  margin-left: 8px;
  overflow: hidden;
  font-size: 16px;
  color: #303c42;
  text-overflow: ellipsis;
  white-space: nowrap;
  align-self: center;
  _margin-left: 20px;
  font-size: 20px;
}

.page-column {
  display: flex;
  flex-direction: column;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/super-pro/super-pro.scss"],"names":[],"mappings":"AAEA;EACE,yBAAA;AADF;;AAIA;EACE,oBAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AADF;;AAIA;EACE,mBAAA;GADA,sBAEA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gHAAA;AADF;;AAIA;EACE,oBAAA;AADF;;AAIA;GADE,kBAEA;AADF;AAGE;EACE,WAAA;EACA,YAAA;EACA,SAAA;AADJ;AAIE;EACE,cAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EAEA,kBAAA;GAJA,iBAKA;EACA,eAAA;AAJF;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAPF","sourcesContent":["\r\n\r\n.flex-auto {\r\n  flex: 1 0 auto !important;\r\n}\r\n\r\n.measurement-list {\r\n  margin-bottom: 140px; // room at the end of the list, also so the fab button never covers the last card\r\n}\r\n\r\n.measurement-card {\r\n  padding: 10px;\r\n}\r\n\r\n.device-status {\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  text-transform: uppercase;\r\n  align-self: center;\r\n  text-align: center;\r\n}\r\n\r\n._ag-card {\r\n  margin-bottom: 10px;\r\n  _border: 2px solid #fff;\r\n  border-radius: 7px;\r\n  margin: 20px;\r\n  padding: 10px;\r\n  background-color: #fff;\r\n  box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12);\r\n}\r\n\r\n.not_synced {\r\n  filter: grayscale(1);\r\n}\r\n\r\n.moisture-row {\r\n  _margin-bottom: 8px;\r\n\r\n  .icon {\r\n    width: 38px;\r\n    height: 38px;\r\n    margin: 0;\r\n  }\r\n\r\n  .moisture-value {\r\n    color: #303c42;\r\n    margin-left: 5px;\r\n    height: 40px;\r\n    font-size: 30px;\r\n    font-weight: 500;\r\n    line-height: 40px;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.moisture-crop {\r\n  margin-top: 5px;\r\n  margin-left: 8px;\r\n  overflow: hidden;\r\n  font-size: 16px;\r\n  color: #303c42;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  \r\n  align-self: center;\r\n  _margin-left: 20px;\r\n  font-size: 20px;\r\n}\r\n\r\n\r\n\r\n// header + content of a page component that is not itself the ion-page\r\n.page-column {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
